import { render, staticRenderFns } from "./CertificateInfo.vue?vue&type=template&id=58af33d4&scoped=true"
import script from "./CertificateInfo.vue?vue&type=script&lang=js"
export * from "./CertificateInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58af33d4",
  null
  
)

export default component.exports